<script lang="ts" setup>
// NOTE: 現状このページへの導線は存在しなくなっているものの、今後追加予定とのこと
import { ref } from "vue";
import { useRouter } from "vue-router";
import Header from "@/components/organisms/common/Header.vue";
import TextFieldGroup from "@/components/molecules/form/TextFieldGroup.vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { accountService } from "@/app/services/AccountService";
import { useLoader } from "@/utils/loader";
import { useErrorModal, useModal } from "@/utils/modal";

const router = useRouter();
const loader = useLoader();
const errorModal = useErrorModal();
const modal = useModal();

const code = ref("");

function onClickBack() {
  router.back();
}
async function applyCode() {
  loader.show();
  try {
    await accountService.applyReferPromotionCode({ code: code.value });
    await showSuccessModal();
    onClickBack();
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    loader.hide();
  }
}
async function showSuccessModal() {
  await modal.msgBoxOk("招待キャンペーンコードの登録が完了しました。", {
    okVariant: "success",
    centered: true
  });
}
</script>

<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      招待コード登録
    </Header>

    <div class="px-3 py-4">
      <CustomValidationObserver ref="vObserver" v-slot="{ handleSubmit }">
        <ValidationProvider
          v-slot="validationState"
          name="招待コード"
          :rules="{ required: true, length: 8 }"
          vid="code"
        >
          <TextFieldGroup
            v-model="code"
            label="招待コード"
            appLabelText="必須"
            placeholder=""
            :validationState="validationState"
            class="mt-3"
          ></TextFieldGroup>
        </ValidationProvider>

        <AppButton
          :block="true"
          class="mt-4"
          :variant="'success'"
          @click="handleSubmit(applyCode)"
        >
          登録する
        </AppButton>
      </CustomValidationObserver>
    </div>
  </div>
</template>
